import React from "react";
import { gsT } from "../i18n";
import styles from "./footer.module.less";
import { Link } from "react-router-dom"; 

export interface FooterProps {
  /** 自定义样式类名 */
  className?: string;
  /** 用户协议链接 */
  userAgreementUrl?: string;
  /** 隐私政策链接 */
  privacyPolicyUrl?: string;
  /** 版权文本（可选，不传则使用默认） */
  copyrightText?: string;
  /** 版权年份范围起始年 */
  startYear?: number;
  /** 版权年份范围结束年（不传则使用当前年份） */
  endYear?: number;
}

/**
 * @description 页面底部Footer组件，包含版权信息和链接
 * @author Cursor
 * @date 2026-01-30
 */
export const Footer: React.FC<FooterProps> = ({
  className = "",
  userAgreementUrl = "/app/agreements/user-agreement",
  privacyPolicyUrl = "/app/agreements/privacy-agreement",
  copyrightText,
  startYear = 2021,
  endYear,
}) => {
  const currentYear = endYear || new Date().getFullYear();
  const yearRange = startYear === currentYear ? `${currentYear}` : `${startYear}-${currentYear}`;
  
  const defaultCopyrightText = `Copyright © ${yearRange} ${gsT("company_name")}`;
  const displayCopyright = copyrightText || defaultCopyrightText;

  return (
    <footer className={`${styles.footer} ${className}`}>
      <div className={styles.container}>
        <span className={styles.copyright}>{displayCopyright}</span>
        <div className={styles.divider} />
        <div className={styles.links}>
          <Link
            to={userAgreementUrl}
            className={styles.link}
          >
            {gsT("user_agreement")}
          </Link>
          <div className={styles.divider} />
          <Link
            to={privacyPolicyUrl}
            className={styles.link}
          >
            {gsT("privacy_policy")}
          </Link>
        </div>
      </div>
    </footer>
  );
};
